import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BlogCard {
  title: string;
  excerpt: string;
  slug: string;
  category: string;
  readTime: string;
  date: string;
  image: string;
  imageAlt: string;
}

const blogArticles: BlogCard[] = [
  {
    title: 'Kakobuy Spreadsheet Polska – Kompletny Guide 2026',
    excerpt: 'Wszystko co musisz wiedzieć o Kakobuy Spreadsheet. Jak działa, gdzie znaleźć najlepsze produkty i jak bezpiecznie kupować z Chin.',
    slug: '/blog/kakobuy-spreadsheet-polska-guide-2026/',
    category: 'Poradniki',
    readTime: '12 min',
    date: '2026-07-16',
    image: 'https://readdy.ai/api/search-image?query=Laptop%20displaying%20spreadsheet%20data%20on%20warm%20cream%20desk%20with%20coffee%20soft%20natural%20lighting%20minimal%20editorial%20photography%20clean%20aesthetic%20warm%20neutral%20tones&width=800&height=500&seq=blog-card-guide-2026&orientation=landscape',
    imageAlt: 'Kakobuy Spreadsheet Polska Guide 2026',
  },
  {
    title: 'Kakobuy vs Superbuy – Który Agent Jest Lepszy?',
    excerpt: 'Pełne porównanie Kakobuy i Superbuy. Opłaty, wysyłka, QC photos i obsługa klienta.',
    slug: '/blog/kakobuy-vs-superbuy/',
    category: 'Porównania',
    readTime: '8 min',
    date: '2026-07-10',
    image: 'https://readdy.ai/api/search-image?query=Two%20shopping%20carts%20facing%20each%20other%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20minimal%20editorial%20flat%20lay%20concept%20photography%20clean%20aesthetic&width=800&height=500&seq=blog-card-vs-superbuy&orientation=landscape',
    imageAlt: 'Kakobuy vs Superbuy porównanie',
  },
  {
    title: 'Najlepszy Sneakers Spreadsheet 2026 – Top 50 Butów',
    excerpt: 'Odkryj najlepsze sneakersy dostępne przez Kakobuy. Nike, Jordan, Adidas, New Balance i więcej.',
    slug: '/blog/kakobuy-sneakers-spreadsheet-2026/',
    category: 'Sneakers',
    readTime: '10 min',
    date: '2026-07-12',
    image: 'https://readdy.ai/api/search-image?query=Three%20pairs%20of%20trendy%20sneakers%20on%20warm%20cream%20wooden%20floor%20soft%20natural%20light%20from%20window%20minimal%20editorial%20product%20photography%20clean%20aesthetic&width=800&height=500&seq=blog-card-sneakers&orientation=landscape',
    imageAlt: 'Najlepszy Sneakers Spreadsheet 2026',
  },
  {
    title: 'Kakobuy Shipping Polska – Kompletny Przewodnik po Wysyłce',
    excerpt: 'Metody wysyłki, koszty, czas dostawy i porady jak uniknąć cła. Niezbędnik każdego kupującego.',
    slug: '/blog/kakobuy-shipping-polska/',
    category: 'Wysyłka',
    readTime: '9 min',
    date: '2026-07-08',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20with%20fragile%20tape%20on%20warm%20cream%20desk%20soft%20natural%20lighting%20minimal%20editorial%20product%20photography%20clean%20aesthetic&width=800&height=500&seq=blog-card-shipping&orientation=landscape',
    imageAlt: 'Kakobuy Shipping Polska przewodnik',
  },
  {
    title: 'Czy Kakobuy Jest Bezpieczny? 10 Zasad',
    excerpt: 'Poznaj 10 kluczowych zasad bezpiecznych zakupów z Chin. Weryfikacja sprzedawców i ochrona pieniędzy.',
    slug: '/blog/kakobuy-bezpieczenstwo/',
    category: 'Bezpieczeństwo',
    readTime: '7 min',
    date: '2026-07-05',
    image: 'https://readdy.ai/api/search-image?query=Padlock%20shield%20icon%20on%20warm%20cream%20surface%20with%20shopping%20bag%20soft%20natural%20lighting%20minimal%20editorial%20security%20concept%20photography%20clean%20aesthetic&width=800&height=500&seq=blog-card-safe&orientation=landscape',
    imageAlt: 'Czy Kakobuy jest bezpieczny',
  },
  {
    title: 'Jak Zacząć z Kakobuy? Poradnik dla Początkujących',
    excerpt: 'Krok po kroku przez proces zakupów. Od rejestracji po pierwszą paczkę w Polsce.',
    slug: '/blog/kakobuy-jak-zaczac/',
    category: 'Poradniki',
    readTime: '6 min',
    date: '2026-07-03',
    image: 'https://readdy.ai/api/search-image?query=Open%20laptop%20with%20shopping%20website%20on%20screen%20warm%20cream%20desk%20with%20notebook%20soft%20natural%20lighting%20minimal%20editorial%20photography%20clean%20aesthetic&width=800&height=500&seq=blog-card-start&orientation=landscape',
    imageAlt: 'Jak zacząć z Kakobuy poradnik',
  },
  {
    title: 'Kakobuy vs PandaBuy – Pełne Porównanie',
    excerpt: 'Szczegółowe porównanie dwóch największych agentów. Ceny, aplikacja, społeczność i wysyłka.',
    slug: '/blog/kakobuy-vs-pandabuy/',
    category: 'Porównania',
    readTime: '8 min',
    date: '2026-07-14',
    image: 'https://readdy.ai/api/search-image?query=Two%20shopping%20bags%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20minimal%20editorial%20comparison%20concept%20photography%20clean%20aesthetic&width=800&height=500&seq=blog-card-pandabuy&orientation=landscape',
    imageAlt: 'Kakobuy vs PandaBuy porównanie',
  },
  {
    title: 'Kakobuy Streetwear Spreadsheet – Marki i Produkty',
    excerpt: 'Supreme, Stussy, Carhartt, Essentials i więcej. Sprawdzone linki do najlepszego streetwearu.',
    slug: '/blog/kakobuy-streetwear-spreadsheet/',
    category: 'Streetwear',
    readTime: '7 min',
    date: '2026-07-11',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20hoodie%20and%20baseball%20cap%20on%20warm%20cream%20concrete%20surface%20soft%20natural%20lighting%20minimal%20editorial%20fashion%20photography%20clean%20aesthetic&width=800&height=500&seq=blog-card-streetwear&orientation=landscape',
    imageAlt: 'Kakobuy Streetwear Spreadsheet',
  },
  {
    title: 'Kakobuy Ceny – Porównanie Cen z Polskimi Sklepami',
    excerpt: 'Ile naprawdę oszczędzasz kupując przez Kakobuy? Porównanie cen butów, ubrań i akcesoriów.',
    slug: '/blog/kakobuy-ceny-porownanie/',
    category: 'Porównania',
    readTime: '7 min',
    date: '2026-07-15',
    image: 'https://readdy.ai/api/search-image?query=Calculator%20and%20price%20tags%20on%20warm%20cream%20surface%20with%20shopping%20bag%20soft%20natural%20lighting%20minimal%20editorial%20still%20life%20photography%20clean%20aesthetic&width=800&height=500&seq=blog-card-prices&orientation=landscape',
    imageAlt: 'Kakobuy ceny porównanie',
  },
];

export default function BlogSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase text-accent-700 bg-accent-100 rounded-full mb-4">
            Blog & Poradniki
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            {t('blog_section_title')}
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            {t('blog_section_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogArticles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-300 hover:shadow-md transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-semibold text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:gap-2 transition-all whitespace-nowrap">
                  {t('blog_read_more')}
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}